import Vue from "vue";
import { format } from "d3";

Vue.filter("number", (val, round = 2) => {
  if (isNaN(val) || val === null) return "-";

  return format(`,.${round}f`)(val);
});

Vue.filter("date", (date) => {
  if (date) {
    const d = new Date(date);

    let days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    let months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    date = `${days[d.getUTCDay() - 1]}, ${d.getUTCDate()} ${
      months[d.getUTCMonth()]
    } ${d.getUTCFullYear()} ${d.getUTCHours()}:${
      d.getUTCMinutes() < 10 ? "0" + d.getUTCMinutes() : d.getUTCMinutes()
    } GMT`;

    // date = d.toUTCString();

    // date = date.substr(0, date.length - 7) ;
  }
  return date;
});
